import { Checkbox, TextField, Typography } from '@arionbanki/arionui';
import { Footer, ProgressBar, SSNInput } from 'components';
import { useMandate } from './useMandate';

export function Mandate() {
	const { data, t, ...props } = useMandate();
	if (!data) return null;
	return (
		<ProgressBar page="mandate">
			<Typography TagName="h3">{props.title}</Typography>
			<Typography className="mb-5" TagName="p">
				{props.description}
			</Typography>
			<p>
				<Checkbox
					checked={props.isMandateVisible}
					id="areMandatesVisible"
					label={props.mandateCheckboxLabel}
					onChange={props.handleIsMandateVisible}
				/>
			</p>
			{props.isMandateVisible && (
				<div className="mt-3 mb-5">
					<Typography TagName="p">
						<small>{props.terms}</small>
					</Typography>
					{props.mandatesCounter.map((key: number, i: number) => (
						<div className="row" key={key}>
							<div className="col-4">
								<SSNInput
									defaultValue={data.generalMandates[i]?.kennitala}
									label={t('mandate_ssn', 'mandate')}
									name="ssn[]"
									validate={props.validate}
								/>
							</div>
							<div className="col-4">
								<TextField
									defaultValue={data.generalMandates[i]?.email}
									label={t('mandate_email', 'mandate')}
									name="email[]"
								/>
							</div>
							{props.mandatesCounter.length > 1 && (
								<div className="col-4 pt-5">
									<button className="btn-link pt-1" onClick={props.handleRemoveMandate} type="button">
										{t('remove_mandate', 'mandate')}&nbsp;&#8722;
									</button>
								</div>
							)}
						</div>
					))}
					{props.mandatesCounter.length < 3 && (
						<button className="btn-link" onClick={props.handleAddMandate} type="button">
							{t('add_mandate', 'mandate')}&nbsp;+
						</button>
					)}
				</div>
			)}
			{props.isAssetRetrievalSectionVisible && (
				<>
					<Typography TagName="p">
						<Checkbox
							checked={props.isAssetVisible}
							id="assetRetrievalMandatesCheck"
							label={props.assetRetrievalCheckboxLabel}
							onChange={props.handleAssetRetrieval}
						/>
					</Typography>
					{props.isAssetVisible && (
						<div className="row">
							<div className="col-12">
								<Typography TagName="p">{props.assetDescription}</Typography>
							</div>
							<div className="col-8">
								<TextField
									defaultValue={data.assetRetrievalMandates[0]?.name}
									label={t('confirm_name', 'mandate')}
									name="assetRetrievalMandates"
								/>
							</div>
							<div className="col-12 mb-5">
								<Typography TagName="p">{t('terms_more', 'mandate')}</Typography>
							</div>
						</div>
					)}
				</>
			)}
			<Footer
				handleNext={props.submit}
				handlePrev={props.goBack}
				isDisabled={false}
				next={t('submit_button_label', 'mandate')}
				prev={t('back')}
			/>
		</ProgressBar>
	);
}
